import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
// import FResourcePropertyEditorDrawer from '@/components/fResourcePropertyEditor/FResourcePropertyEditorDrawer';
import ResourceTypeInputDrawer from './ResourceTypeInputDrawer';

type ReturnDataType = {
  value: string;
  labels: string[];
  customInput?: string;
} | null;

interface fResourceTypeInputDrawerProps {

}

function fResourceTypeInputDrawer({}: fResourceTypeInputDrawerProps = {}): Promise<ReturnDataType> {
  return new Promise<ReturnDataType>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(<ResourceTypeInputDrawer
      onOk={(obj) => {
        resolve(obj);
      }}
      onClose={() => {
        resolve(null);
        setTimeout(() => {
          root.unmount();
          div.remove();
        }, 300);
      }}
    />);
  });
}

export default fResourceTypeInputDrawer;
